/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TvRouteImport } from './routes/tv'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as ShellIndexRouteImport } from './routes/_shell.index'
import { Route as PortalTokenRouteImport } from './routes/portal.$token'
import { Route as ChatbotPreviewRouteImport } from './routes/chatbot_.preview'
import { Route as ShellUsersRouteImport } from './routes/_shell.users'
import { Route as ShellUploadDataRouteImport } from './routes/_shell.upload-data'
import { Route as ShellTestPortalsRouteImport } from './routes/_shell.test-portals'
import { Route as ShellStatisticsRouteImport } from './routes/_shell.statistics'
import { Route as ShellSmartProductDisplaysSolutionsGuideDotmdRouteImport } from './routes/_shell.smart-product-displays-solutions-guide[.]md'
import { Route as ShellSelectOrganizationRouteImport } from './routes/_shell.select-organization'
import { Route as ShellRulesRouteImport } from './routes/_shell.rules'
import { Route as ShellRevenueRouteImport } from './routes/_shell.revenue'
import { Route as ShellPromptTemplateRouteImport } from './routes/_shell.prompt-template'
import { Route as ShellProductAnalyticsRouteImport } from './routes/_shell.product-analytics'
import { Route as ShellMissingInfoTicketsRouteImport } from './routes/_shell.missing-info-tickets'
import { Route as ShellLoginRouteImport } from './routes/_shell.login'
import { Route as ShellInternalDocsRouteImport } from './routes/_shell.internal-docs'
import { Route as ShellIntegrationsRouteImport } from './routes/_shell.integrations'
import { Route as ShellDeveloperRouteImport } from './routes/_shell.developer'
import { Route as ShellDevBoardRouteImport } from './routes/_shell.dev-board'
import { Route as ShellConnectAiRouteImport } from './routes/_shell.connect-ai'
import { Route as ShellChatbotIdsRouteImport } from './routes/_shell.chatbot-ids'
import { Route as ShellChatbotRouteImport } from './routes/_shell.chatbot'
import { Route as ShellBenchmarkRouteImport } from './routes/_shell.benchmark'
import { Route as ShellBehaviourRouteImport } from './routes/_shell.behaviour'
import { Route as ShellAgentProposalsRouteImport } from './routes/_shell.agent-proposals'
import { Route as ShellSplatRouteImport } from './routes/_shell.$'
import { Route as ShellSolutionsIndexRouteImport } from './routes/_shell.solutions.index'
import { Route as ShellOrganizationsIndexRouteImport } from './routes/_shell.organizations.index'
import { Route as ShellLivechatIndexRouteImport } from './routes/_shell.livechat.index'
import { Route as ShellExperimentsIndexRouteImport } from './routes/_shell.experiments.index'
import { Route as ShellBehaviourStudioIndexRouteImport } from './routes/_shell.behaviour-studio.index'
import { Route as ShellBehaviorIndexRouteImport } from './routes/_shell.behavior.index'
import { Route as ShellUsersOrgIdRouteImport } from './routes/_shell.users.$orgId'
import { Route as ShellSolutionsOrgIdRouteImport } from './routes/_shell.solutions.$orgId'
import { Route as ShellOrganizationsOrgIdRouteImport } from './routes/_shell.organizations.$orgId'
import { Route as ShellLivechatCannedResponsesRouteImport } from './routes/_shell.livechat.canned-responses'
import { Route as ShellExperimentsProcessRouteImport } from './routes/_shell.experiments.process'
import { Route as ShellExperimentsLearnedRouteImport } from './routes/_shell.experiments.learned'
import { Route as ShellExperimentsExperimentIdRouteImport } from './routes/_shell.experiments.$experimentId'
import { Route as ShellBehaviourStudioOrgIdRouteImport } from './routes/_shell.behaviour-studio.$orgId'
import { Route as ShellBehaviorBannersRouteImport } from './routes/_shell.behavior.banners'
import { Route as ShellAuthCallbackRouteImport } from './routes/_shell.auth.callback'

const TvRoute = TvRouteImport.update({
  id: '/tv',
  path: '/tv',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellIndexRoute = ShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellRoute,
} as any)
const PortalTokenRoute = PortalTokenRouteImport.update({
  id: '/portal/$token',
  path: '/portal/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatbotPreviewRoute = ChatbotPreviewRouteImport.update({
  id: '/chatbot_/preview',
  path: '/chatbot/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellUsersRoute = ShellUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => ShellRoute,
} as any)
const ShellUploadDataRoute = ShellUploadDataRouteImport.update({
  id: '/upload-data',
  path: '/upload-data',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTestPortalsRoute = ShellTestPortalsRouteImport.update({
  id: '/test-portals',
  path: '/test-portals',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStatisticsRoute = ShellStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSmartProductDisplaysSolutionsGuideDotmdRoute =
  ShellSmartProductDisplaysSolutionsGuideDotmdRouteImport.update({
    id: '/smart-product-displays-solutions-guide.md',
    path: '/smart-product-displays-solutions-guide.md',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellSelectOrganizationRoute = ShellSelectOrganizationRouteImport.update({
  id: '/select-organization',
  path: '/select-organization',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRulesRoute = ShellRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRevenueRoute = ShellRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPromptTemplateRoute = ShellPromptTemplateRouteImport.update({
  id: '/prompt-template',
  path: '/prompt-template',
  getParentRoute: () => ShellRoute,
} as any)
const ShellProductAnalyticsRoute = ShellProductAnalyticsRouteImport.update({
  id: '/product-analytics',
  path: '/product-analytics',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMissingInfoTicketsRoute = ShellMissingInfoTicketsRouteImport.update({
  id: '/missing-info-tickets',
  path: '/missing-info-tickets',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLoginRoute = ShellLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => ShellRoute,
} as any)
const ShellInternalDocsRoute = ShellInternalDocsRouteImport.update({
  id: '/internal-docs',
  path: '/internal-docs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellIntegrationsRoute = ShellIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDeveloperRoute = ShellDeveloperRouteImport.update({
  id: '/developer',
  path: '/developer',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDevBoardRoute = ShellDevBoardRouteImport.update({
  id: '/dev-board',
  path: '/dev-board',
  getParentRoute: () => ShellRoute,
} as any)
const ShellConnectAiRoute = ShellConnectAiRouteImport.update({
  id: '/connect-ai',
  path: '/connect-ai',
  getParentRoute: () => ShellRoute,
} as any)
const ShellChatbotIdsRoute = ShellChatbotIdsRouteImport.update({
  id: '/chatbot-ids',
  path: '/chatbot-ids',
  getParentRoute: () => ShellRoute,
} as any)
const ShellChatbotRoute = ShellChatbotRouteImport.update({
  id: '/chatbot',
  path: '/chatbot',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBenchmarkRoute = ShellBenchmarkRouteImport.update({
  id: '/benchmark',
  path: '/benchmark',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBehaviourRoute = ShellBehaviourRouteImport.update({
  id: '/behaviour',
  path: '/behaviour',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAgentProposalsRoute = ShellAgentProposalsRouteImport.update({
  id: '/agent-proposals',
  path: '/agent-proposals',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSplatRoute = ShellSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSolutionsIndexRoute = ShellSolutionsIndexRouteImport.update({
  id: '/solutions/',
  path: '/solutions/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrganizationsIndexRoute = ShellOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLivechatIndexRoute = ShellLivechatIndexRouteImport.update({
  id: '/livechat/',
  path: '/livechat/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellExperimentsIndexRoute = ShellExperimentsIndexRouteImport.update({
  id: '/experiments/',
  path: '/experiments/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBehaviourStudioIndexRoute =
  ShellBehaviourStudioIndexRouteImport.update({
    id: '/behaviour-studio/',
    path: '/behaviour-studio/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellBehaviorIndexRoute = ShellBehaviorIndexRouteImport.update({
  id: '/behavior/',
  path: '/behavior/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellUsersOrgIdRoute = ShellUsersOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => ShellUsersRoute,
} as any)
const ShellSolutionsOrgIdRoute = ShellSolutionsOrgIdRouteImport.update({
  id: '/solutions/$orgId',
  path: '/solutions/$orgId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrganizationsOrgIdRoute = ShellOrganizationsOrgIdRouteImport.update({
  id: '/organizations/$orgId',
  path: '/organizations/$orgId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLivechatCannedResponsesRoute =
  ShellLivechatCannedResponsesRouteImport.update({
    id: '/livechat/canned-responses',
    path: '/livechat/canned-responses',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellExperimentsProcessRoute = ShellExperimentsProcessRouteImport.update({
  id: '/experiments/process',
  path: '/experiments/process',
  getParentRoute: () => ShellRoute,
} as any)
const ShellExperimentsLearnedRoute = ShellExperimentsLearnedRouteImport.update({
  id: '/experiments/learned',
  path: '/experiments/learned',
  getParentRoute: () => ShellRoute,
} as any)
const ShellExperimentsExperimentIdRoute =
  ShellExperimentsExperimentIdRouteImport.update({
    id: '/experiments/$experimentId',
    path: '/experiments/$experimentId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellBehaviourStudioOrgIdRoute =
  ShellBehaviourStudioOrgIdRouteImport.update({
    id: '/behaviour-studio/$orgId',
    path: '/behaviour-studio/$orgId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellBehaviorBannersRoute = ShellBehaviorBannersRouteImport.update({
  id: '/behavior/banners',
  path: '/behavior/banners',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAuthCallbackRoute = ShellAuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => ShellRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ShellIndexRoute
  '/tv': typeof TvRoute
  '/$': typeof ShellSplatRoute
  '/agent-proposals': typeof ShellAgentProposalsRoute
  '/behaviour': typeof ShellBehaviourRoute
  '/benchmark': typeof ShellBenchmarkRoute
  '/chatbot': typeof ShellChatbotRoute
  '/chatbot-ids': typeof ShellChatbotIdsRoute
  '/connect-ai': typeof ShellConnectAiRoute
  '/dev-board': typeof ShellDevBoardRoute
  '/developer': typeof ShellDeveloperRoute
  '/integrations': typeof ShellIntegrationsRoute
  '/internal-docs': typeof ShellInternalDocsRoute
  '/login': typeof ShellLoginRoute
  '/missing-info-tickets': typeof ShellMissingInfoTicketsRoute
  '/product-analytics': typeof ShellProductAnalyticsRoute
  '/prompt-template': typeof ShellPromptTemplateRoute
  '/revenue': typeof ShellRevenueRoute
  '/rules': typeof ShellRulesRoute
  '/select-organization': typeof ShellSelectOrganizationRoute
  '/smart-product-displays-solutions-guide.md': typeof ShellSmartProductDisplaysSolutionsGuideDotmdRoute
  '/statistics': typeof ShellStatisticsRoute
  '/test-portals': typeof ShellTestPortalsRoute
  '/upload-data': typeof ShellUploadDataRoute
  '/users': typeof ShellUsersRouteWithChildren
  '/chatbot/preview': typeof ChatbotPreviewRoute
  '/portal/$token': typeof PortalTokenRoute
  '/auth/callback': typeof ShellAuthCallbackRoute
  '/behavior/banners': typeof ShellBehaviorBannersRoute
  '/behaviour-studio/$orgId': typeof ShellBehaviourStudioOrgIdRoute
  '/experiments/$experimentId': typeof ShellExperimentsExperimentIdRoute
  '/experiments/learned': typeof ShellExperimentsLearnedRoute
  '/experiments/process': typeof ShellExperimentsProcessRoute
  '/livechat/canned-responses': typeof ShellLivechatCannedResponsesRoute
  '/organizations/$orgId': typeof ShellOrganizationsOrgIdRoute
  '/solutions/$orgId': typeof ShellSolutionsOrgIdRoute
  '/users/$orgId': typeof ShellUsersOrgIdRoute
  '/behavior/': typeof ShellBehaviorIndexRoute
  '/behaviour-studio/': typeof ShellBehaviourStudioIndexRoute
  '/experiments/': typeof ShellExperimentsIndexRoute
  '/livechat/': typeof ShellLivechatIndexRoute
  '/organizations/': typeof ShellOrganizationsIndexRoute
  '/solutions/': typeof ShellSolutionsIndexRoute
}
export interface FileRoutesByTo {
  '/tv': typeof TvRoute
  '/$': typeof ShellSplatRoute
  '/agent-proposals': typeof ShellAgentProposalsRoute
  '/behaviour': typeof ShellBehaviourRoute
  '/benchmark': typeof ShellBenchmarkRoute
  '/chatbot': typeof ShellChatbotRoute
  '/chatbot-ids': typeof ShellChatbotIdsRoute
  '/connect-ai': typeof ShellConnectAiRoute
  '/dev-board': typeof ShellDevBoardRoute
  '/developer': typeof ShellDeveloperRoute
  '/integrations': typeof ShellIntegrationsRoute
  '/internal-docs': typeof ShellInternalDocsRoute
  '/login': typeof ShellLoginRoute
  '/missing-info-tickets': typeof ShellMissingInfoTicketsRoute
  '/product-analytics': typeof ShellProductAnalyticsRoute
  '/prompt-template': typeof ShellPromptTemplateRoute
  '/revenue': typeof ShellRevenueRoute
  '/rules': typeof ShellRulesRoute
  '/select-organization': typeof ShellSelectOrganizationRoute
  '/smart-product-displays-solutions-guide.md': typeof ShellSmartProductDisplaysSolutionsGuideDotmdRoute
  '/statistics': typeof ShellStatisticsRoute
  '/test-portals': typeof ShellTestPortalsRoute
  '/upload-data': typeof ShellUploadDataRoute
  '/users': typeof ShellUsersRouteWithChildren
  '/chatbot/preview': typeof ChatbotPreviewRoute
  '/portal/$token': typeof PortalTokenRoute
  '/': typeof ShellIndexRoute
  '/auth/callback': typeof ShellAuthCallbackRoute
  '/behavior/banners': typeof ShellBehaviorBannersRoute
  '/behaviour-studio/$orgId': typeof ShellBehaviourStudioOrgIdRoute
  '/experiments/$experimentId': typeof ShellExperimentsExperimentIdRoute
  '/experiments/learned': typeof ShellExperimentsLearnedRoute
  '/experiments/process': typeof ShellExperimentsProcessRoute
  '/livechat/canned-responses': typeof ShellLivechatCannedResponsesRoute
  '/organizations/$orgId': typeof ShellOrganizationsOrgIdRoute
  '/solutions/$orgId': typeof ShellSolutionsOrgIdRoute
  '/users/$orgId': typeof ShellUsersOrgIdRoute
  '/behavior': typeof ShellBehaviorIndexRoute
  '/behaviour-studio': typeof ShellBehaviourStudioIndexRoute
  '/experiments': typeof ShellExperimentsIndexRoute
  '/livechat': typeof ShellLivechatIndexRoute
  '/organizations': typeof ShellOrganizationsIndexRoute
  '/solutions': typeof ShellSolutionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_shell': typeof ShellRouteWithChildren
  '/tv': typeof TvRoute
  '/_shell/$': typeof ShellSplatRoute
  '/_shell/agent-proposals': typeof ShellAgentProposalsRoute
  '/_shell/behaviour': typeof ShellBehaviourRoute
  '/_shell/benchmark': typeof ShellBenchmarkRoute
  '/_shell/chatbot': typeof ShellChatbotRoute
  '/_shell/chatbot-ids': typeof ShellChatbotIdsRoute
  '/_shell/connect-ai': typeof ShellConnectAiRoute
  '/_shell/dev-board': typeof ShellDevBoardRoute
  '/_shell/developer': typeof ShellDeveloperRoute
  '/_shell/integrations': typeof ShellIntegrationsRoute
  '/_shell/internal-docs': typeof ShellInternalDocsRoute
  '/_shell/login': typeof ShellLoginRoute
  '/_shell/missing-info-tickets': typeof ShellMissingInfoTicketsRoute
  '/_shell/product-analytics': typeof ShellProductAnalyticsRoute
  '/_shell/prompt-template': typeof ShellPromptTemplateRoute
  '/_shell/revenue': typeof ShellRevenueRoute
  '/_shell/rules': typeof ShellRulesRoute
  '/_shell/select-organization': typeof ShellSelectOrganizationRoute
  '/_shell/smart-product-displays-solutions-guide.md': typeof ShellSmartProductDisplaysSolutionsGuideDotmdRoute
  '/_shell/statistics': typeof ShellStatisticsRoute
  '/_shell/test-portals': typeof ShellTestPortalsRoute
  '/_shell/upload-data': typeof ShellUploadDataRoute
  '/_shell/users': typeof ShellUsersRouteWithChildren
  '/chatbot_/preview': typeof ChatbotPreviewRoute
  '/portal/$token': typeof PortalTokenRoute
  '/_shell/': typeof ShellIndexRoute
  '/_shell/auth/callback': typeof ShellAuthCallbackRoute
  '/_shell/behavior/banners': typeof ShellBehaviorBannersRoute
  '/_shell/behaviour-studio/$orgId': typeof ShellBehaviourStudioOrgIdRoute
  '/_shell/experiments/$experimentId': typeof ShellExperimentsExperimentIdRoute
  '/_shell/experiments/learned': typeof ShellExperimentsLearnedRoute
  '/_shell/experiments/process': typeof ShellExperimentsProcessRoute
  '/_shell/livechat/canned-responses': typeof ShellLivechatCannedResponsesRoute
  '/_shell/organizations/$orgId': typeof ShellOrganizationsOrgIdRoute
  '/_shell/solutions/$orgId': typeof ShellSolutionsOrgIdRoute
  '/_shell/users/$orgId': typeof ShellUsersOrgIdRoute
  '/_shell/behavior/': typeof ShellBehaviorIndexRoute
  '/_shell/behaviour-studio/': typeof ShellBehaviourStudioIndexRoute
  '/_shell/experiments/': typeof ShellExperimentsIndexRoute
  '/_shell/livechat/': typeof ShellLivechatIndexRoute
  '/_shell/organizations/': typeof ShellOrganizationsIndexRoute
  '/_shell/solutions/': typeof ShellSolutionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/tv'
    | '/$'
    | '/agent-proposals'
    | '/behaviour'
    | '/benchmark'
    | '/chatbot'
    | '/chatbot-ids'
    | '/connect-ai'
    | '/dev-board'
    | '/developer'
    | '/integrations'
    | '/internal-docs'
    | '/login'
    | '/missing-info-tickets'
    | '/product-analytics'
    | '/prompt-template'
    | '/revenue'
    | '/rules'
    | '/select-organization'
    | '/smart-product-displays-solutions-guide.md'
    | '/statistics'
    | '/test-portals'
    | '/upload-data'
    | '/users'
    | '/chatbot/preview'
    | '/portal/$token'
    | '/auth/callback'
    | '/behavior/banners'
    | '/behaviour-studio/$orgId'
    | '/experiments/$experimentId'
    | '/experiments/learned'
    | '/experiments/process'
    | '/livechat/canned-responses'
    | '/organizations/$orgId'
    | '/solutions/$orgId'
    | '/users/$orgId'
    | '/behavior/'
    | '/behaviour-studio/'
    | '/experiments/'
    | '/livechat/'
    | '/organizations/'
    | '/solutions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/tv'
    | '/$'
    | '/agent-proposals'
    | '/behaviour'
    | '/benchmark'
    | '/chatbot'
    | '/chatbot-ids'
    | '/connect-ai'
    | '/dev-board'
    | '/developer'
    | '/integrations'
    | '/internal-docs'
    | '/login'
    | '/missing-info-tickets'
    | '/product-analytics'
    | '/prompt-template'
    | '/revenue'
    | '/rules'
    | '/select-organization'
    | '/smart-product-displays-solutions-guide.md'
    | '/statistics'
    | '/test-portals'
    | '/upload-data'
    | '/users'
    | '/chatbot/preview'
    | '/portal/$token'
    | '/'
    | '/auth/callback'
    | '/behavior/banners'
    | '/behaviour-studio/$orgId'
    | '/experiments/$experimentId'
    | '/experiments/learned'
    | '/experiments/process'
    | '/livechat/canned-responses'
    | '/organizations/$orgId'
    | '/solutions/$orgId'
    | '/users/$orgId'
    | '/behavior'
    | '/behaviour-studio'
    | '/experiments'
    | '/livechat'
    | '/organizations'
    | '/solutions'
  id:
    | '__root__'
    | '/_shell'
    | '/tv'
    | '/_shell/$'
    | '/_shell/agent-proposals'
    | '/_shell/behaviour'
    | '/_shell/benchmark'
    | '/_shell/chatbot'
    | '/_shell/chatbot-ids'
    | '/_shell/connect-ai'
    | '/_shell/dev-board'
    | '/_shell/developer'
    | '/_shell/integrations'
    | '/_shell/internal-docs'
    | '/_shell/login'
    | '/_shell/missing-info-tickets'
    | '/_shell/product-analytics'
    | '/_shell/prompt-template'
    | '/_shell/revenue'
    | '/_shell/rules'
    | '/_shell/select-organization'
    | '/_shell/smart-product-displays-solutions-guide.md'
    | '/_shell/statistics'
    | '/_shell/test-portals'
    | '/_shell/upload-data'
    | '/_shell/users'
    | '/chatbot_/preview'
    | '/portal/$token'
    | '/_shell/'
    | '/_shell/auth/callback'
    | '/_shell/behavior/banners'
    | '/_shell/behaviour-studio/$orgId'
    | '/_shell/experiments/$experimentId'
    | '/_shell/experiments/learned'
    | '/_shell/experiments/process'
    | '/_shell/livechat/canned-responses'
    | '/_shell/organizations/$orgId'
    | '/_shell/solutions/$orgId'
    | '/_shell/users/$orgId'
    | '/_shell/behavior/'
    | '/_shell/behaviour-studio/'
    | '/_shell/experiments/'
    | '/_shell/livechat/'
    | '/_shell/organizations/'
    | '/_shell/solutions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ShellRoute: typeof ShellRouteWithChildren
  TvRoute: typeof TvRoute
  ChatbotPreviewRoute: typeof ChatbotPreviewRoute
  PortalTokenRoute: typeof PortalTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tv': {
      id: '/tv'
      path: '/tv'
      fullPath: '/tv'
      preLoaderRoute: typeof TvRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/': {
      id: '/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ShellIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/portal/$token': {
      id: '/portal/$token'
      path: '/portal/$token'
      fullPath: '/portal/$token'
      preLoaderRoute: typeof PortalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chatbot_/preview': {
      id: '/chatbot_/preview'
      path: '/chatbot/preview'
      fullPath: '/chatbot/preview'
      preLoaderRoute: typeof ChatbotPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/users': {
      id: '/_shell/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof ShellUsersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/upload-data': {
      id: '/_shell/upload-data'
      path: '/upload-data'
      fullPath: '/upload-data'
      preLoaderRoute: typeof ShellUploadDataRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/test-portals': {
      id: '/_shell/test-portals'
      path: '/test-portals'
      fullPath: '/test-portals'
      preLoaderRoute: typeof ShellTestPortalsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/statistics': {
      id: '/_shell/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof ShellStatisticsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/smart-product-displays-solutions-guide.md': {
      id: '/_shell/smart-product-displays-solutions-guide.md'
      path: '/smart-product-displays-solutions-guide.md'
      fullPath: '/smart-product-displays-solutions-guide.md'
      preLoaderRoute: typeof ShellSmartProductDisplaysSolutionsGuideDotmdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/select-organization': {
      id: '/_shell/select-organization'
      path: '/select-organization'
      fullPath: '/select-organization'
      preLoaderRoute: typeof ShellSelectOrganizationRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/rules': {
      id: '/_shell/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof ShellRulesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/revenue': {
      id: '/_shell/revenue'
      path: '/revenue'
      fullPath: '/revenue'
      preLoaderRoute: typeof ShellRevenueRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/prompt-template': {
      id: '/_shell/prompt-template'
      path: '/prompt-template'
      fullPath: '/prompt-template'
      preLoaderRoute: typeof ShellPromptTemplateRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/product-analytics': {
      id: '/_shell/product-analytics'
      path: '/product-analytics'
      fullPath: '/product-analytics'
      preLoaderRoute: typeof ShellProductAnalyticsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/missing-info-tickets': {
      id: '/_shell/missing-info-tickets'
      path: '/missing-info-tickets'
      fullPath: '/missing-info-tickets'
      preLoaderRoute: typeof ShellMissingInfoTicketsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/login': {
      id: '/_shell/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof ShellLoginRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/internal-docs': {
      id: '/_shell/internal-docs'
      path: '/internal-docs'
      fullPath: '/internal-docs'
      preLoaderRoute: typeof ShellInternalDocsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/integrations': {
      id: '/_shell/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof ShellIntegrationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/developer': {
      id: '/_shell/developer'
      path: '/developer'
      fullPath: '/developer'
      preLoaderRoute: typeof ShellDeveloperRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/dev-board': {
      id: '/_shell/dev-board'
      path: '/dev-board'
      fullPath: '/dev-board'
      preLoaderRoute: typeof ShellDevBoardRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/connect-ai': {
      id: '/_shell/connect-ai'
      path: '/connect-ai'
      fullPath: '/connect-ai'
      preLoaderRoute: typeof ShellConnectAiRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/chatbot-ids': {
      id: '/_shell/chatbot-ids'
      path: '/chatbot-ids'
      fullPath: '/chatbot-ids'
      preLoaderRoute: typeof ShellChatbotIdsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/chatbot': {
      id: '/_shell/chatbot'
      path: '/chatbot'
      fullPath: '/chatbot'
      preLoaderRoute: typeof ShellChatbotRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/benchmark': {
      id: '/_shell/benchmark'
      path: '/benchmark'
      fullPath: '/benchmark'
      preLoaderRoute: typeof ShellBenchmarkRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/behaviour': {
      id: '/_shell/behaviour'
      path: '/behaviour'
      fullPath: '/behaviour'
      preLoaderRoute: typeof ShellBehaviourRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/agent-proposals': {
      id: '/_shell/agent-proposals'
      path: '/agent-proposals'
      fullPath: '/agent-proposals'
      preLoaderRoute: typeof ShellAgentProposalsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/$': {
      id: '/_shell/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof ShellSplatRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/solutions/': {
      id: '/_shell/solutions/'
      path: '/solutions'
      fullPath: '/solutions/'
      preLoaderRoute: typeof ShellSolutionsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/organizations/': {
      id: '/_shell/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof ShellOrganizationsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/livechat/': {
      id: '/_shell/livechat/'
      path: '/livechat'
      fullPath: '/livechat/'
      preLoaderRoute: typeof ShellLivechatIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/experiments/': {
      id: '/_shell/experiments/'
      path: '/experiments'
      fullPath: '/experiments/'
      preLoaderRoute: typeof ShellExperimentsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/behaviour-studio/': {
      id: '/_shell/behaviour-studio/'
      path: '/behaviour-studio'
      fullPath: '/behaviour-studio/'
      preLoaderRoute: typeof ShellBehaviourStudioIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/behavior/': {
      id: '/_shell/behavior/'
      path: '/behavior'
      fullPath: '/behavior/'
      preLoaderRoute: typeof ShellBehaviorIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/users/$orgId': {
      id: '/_shell/users/$orgId'
      path: '/$orgId'
      fullPath: '/users/$orgId'
      preLoaderRoute: typeof ShellUsersOrgIdRouteImport
      parentRoute: typeof ShellUsersRoute
    }
    '/_shell/solutions/$orgId': {
      id: '/_shell/solutions/$orgId'
      path: '/solutions/$orgId'
      fullPath: '/solutions/$orgId'
      preLoaderRoute: typeof ShellSolutionsOrgIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/organizations/$orgId': {
      id: '/_shell/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/organizations/$orgId'
      preLoaderRoute: typeof ShellOrganizationsOrgIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/livechat/canned-responses': {
      id: '/_shell/livechat/canned-responses'
      path: '/livechat/canned-responses'
      fullPath: '/livechat/canned-responses'
      preLoaderRoute: typeof ShellLivechatCannedResponsesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/experiments/process': {
      id: '/_shell/experiments/process'
      path: '/experiments/process'
      fullPath: '/experiments/process'
      preLoaderRoute: typeof ShellExperimentsProcessRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/experiments/learned': {
      id: '/_shell/experiments/learned'
      path: '/experiments/learned'
      fullPath: '/experiments/learned'
      preLoaderRoute: typeof ShellExperimentsLearnedRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/experiments/$experimentId': {
      id: '/_shell/experiments/$experimentId'
      path: '/experiments/$experimentId'
      fullPath: '/experiments/$experimentId'
      preLoaderRoute: typeof ShellExperimentsExperimentIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/behaviour-studio/$orgId': {
      id: '/_shell/behaviour-studio/$orgId'
      path: '/behaviour-studio/$orgId'
      fullPath: '/behaviour-studio/$orgId'
      preLoaderRoute: typeof ShellBehaviourStudioOrgIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/behavior/banners': {
      id: '/_shell/behavior/banners'
      path: '/behavior/banners'
      fullPath: '/behavior/banners'
      preLoaderRoute: typeof ShellBehaviorBannersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/auth/callback': {
      id: '/_shell/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof ShellAuthCallbackRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellUsersRouteChildren {
  ShellUsersOrgIdRoute: typeof ShellUsersOrgIdRoute
}

const ShellUsersRouteChildren: ShellUsersRouteChildren = {
  ShellUsersOrgIdRoute: ShellUsersOrgIdRoute,
}

const ShellUsersRouteWithChildren = ShellUsersRoute._addFileChildren(
  ShellUsersRouteChildren,
)

interface ShellRouteChildren {
  ShellSplatRoute: typeof ShellSplatRoute
  ShellAgentProposalsRoute: typeof ShellAgentProposalsRoute
  ShellBehaviourRoute: typeof ShellBehaviourRoute
  ShellBenchmarkRoute: typeof ShellBenchmarkRoute
  ShellChatbotRoute: typeof ShellChatbotRoute
  ShellChatbotIdsRoute: typeof ShellChatbotIdsRoute
  ShellConnectAiRoute: typeof ShellConnectAiRoute
  ShellDevBoardRoute: typeof ShellDevBoardRoute
  ShellDeveloperRoute: typeof ShellDeveloperRoute
  ShellIntegrationsRoute: typeof ShellIntegrationsRoute
  ShellInternalDocsRoute: typeof ShellInternalDocsRoute
  ShellLoginRoute: typeof ShellLoginRoute
  ShellMissingInfoTicketsRoute: typeof ShellMissingInfoTicketsRoute
  ShellProductAnalyticsRoute: typeof ShellProductAnalyticsRoute
  ShellPromptTemplateRoute: typeof ShellPromptTemplateRoute
  ShellRevenueRoute: typeof ShellRevenueRoute
  ShellRulesRoute: typeof ShellRulesRoute
  ShellSelectOrganizationRoute: typeof ShellSelectOrganizationRoute
  ShellSmartProductDisplaysSolutionsGuideDotmdRoute: typeof ShellSmartProductDisplaysSolutionsGuideDotmdRoute
  ShellStatisticsRoute: typeof ShellStatisticsRoute
  ShellTestPortalsRoute: typeof ShellTestPortalsRoute
  ShellUploadDataRoute: typeof ShellUploadDataRoute
  ShellUsersRoute: typeof ShellUsersRouteWithChildren
  ShellIndexRoute: typeof ShellIndexRoute
  ShellAuthCallbackRoute: typeof ShellAuthCallbackRoute
  ShellBehaviorBannersRoute: typeof ShellBehaviorBannersRoute
  ShellBehaviourStudioOrgIdRoute: typeof ShellBehaviourStudioOrgIdRoute
  ShellExperimentsExperimentIdRoute: typeof ShellExperimentsExperimentIdRoute
  ShellExperimentsLearnedRoute: typeof ShellExperimentsLearnedRoute
  ShellExperimentsProcessRoute: typeof ShellExperimentsProcessRoute
  ShellLivechatCannedResponsesRoute: typeof ShellLivechatCannedResponsesRoute
  ShellOrganizationsOrgIdRoute: typeof ShellOrganizationsOrgIdRoute
  ShellSolutionsOrgIdRoute: typeof ShellSolutionsOrgIdRoute
  ShellBehaviorIndexRoute: typeof ShellBehaviorIndexRoute
  ShellBehaviourStudioIndexRoute: typeof ShellBehaviourStudioIndexRoute
  ShellExperimentsIndexRoute: typeof ShellExperimentsIndexRoute
  ShellLivechatIndexRoute: typeof ShellLivechatIndexRoute
  ShellOrganizationsIndexRoute: typeof ShellOrganizationsIndexRoute
  ShellSolutionsIndexRoute: typeof ShellSolutionsIndexRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellSplatRoute: ShellSplatRoute,
  ShellAgentProposalsRoute: ShellAgentProposalsRoute,
  ShellBehaviourRoute: ShellBehaviourRoute,
  ShellBenchmarkRoute: ShellBenchmarkRoute,
  ShellChatbotRoute: ShellChatbotRoute,
  ShellChatbotIdsRoute: ShellChatbotIdsRoute,
  ShellConnectAiRoute: ShellConnectAiRoute,
  ShellDevBoardRoute: ShellDevBoardRoute,
  ShellDeveloperRoute: ShellDeveloperRoute,
  ShellIntegrationsRoute: ShellIntegrationsRoute,
  ShellInternalDocsRoute: ShellInternalDocsRoute,
  ShellLoginRoute: ShellLoginRoute,
  ShellMissingInfoTicketsRoute: ShellMissingInfoTicketsRoute,
  ShellProductAnalyticsRoute: ShellProductAnalyticsRoute,
  ShellPromptTemplateRoute: ShellPromptTemplateRoute,
  ShellRevenueRoute: ShellRevenueRoute,
  ShellRulesRoute: ShellRulesRoute,
  ShellSelectOrganizationRoute: ShellSelectOrganizationRoute,
  ShellSmartProductDisplaysSolutionsGuideDotmdRoute:
    ShellSmartProductDisplaysSolutionsGuideDotmdRoute,
  ShellStatisticsRoute: ShellStatisticsRoute,
  ShellTestPortalsRoute: ShellTestPortalsRoute,
  ShellUploadDataRoute: ShellUploadDataRoute,
  ShellUsersRoute: ShellUsersRouteWithChildren,
  ShellIndexRoute: ShellIndexRoute,
  ShellAuthCallbackRoute: ShellAuthCallbackRoute,
  ShellBehaviorBannersRoute: ShellBehaviorBannersRoute,
  ShellBehaviourStudioOrgIdRoute: ShellBehaviourStudioOrgIdRoute,
  ShellExperimentsExperimentIdRoute: ShellExperimentsExperimentIdRoute,
  ShellExperimentsLearnedRoute: ShellExperimentsLearnedRoute,
  ShellExperimentsProcessRoute: ShellExperimentsProcessRoute,
  ShellLivechatCannedResponsesRoute: ShellLivechatCannedResponsesRoute,
  ShellOrganizationsOrgIdRoute: ShellOrganizationsOrgIdRoute,
  ShellSolutionsOrgIdRoute: ShellSolutionsOrgIdRoute,
  ShellBehaviorIndexRoute: ShellBehaviorIndexRoute,
  ShellBehaviourStudioIndexRoute: ShellBehaviourStudioIndexRoute,
  ShellExperimentsIndexRoute: ShellExperimentsIndexRoute,
  ShellLivechatIndexRoute: ShellLivechatIndexRoute,
  ShellOrganizationsIndexRoute: ShellOrganizationsIndexRoute,
  ShellSolutionsIndexRoute: ShellSolutionsIndexRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ShellRoute: ShellRouteWithChildren,
  TvRoute: TvRoute,
  ChatbotPreviewRoute: ChatbotPreviewRoute,
  PortalTokenRoute: PortalTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
